import { render } from "./LoginForm.vue?vue&type=template&id=07f0145f"
import script from "./LoginForm.vue?vue&type=script&lang=ts"
export * from "./LoginForm.vue?vue&type=script&lang=ts"
script.render = render

export default script